(function(){
  'use strict';

  var MONTHLY_IMG='https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_monthly_subscription_box.webp?v=1789336197';
  var ONE_POUND_IMG='https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_one_pound_or_less.webp?v=1789336197';
  var BUNDLES_IMG='https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_all_bundles.webp?v=1789336197';
  var GIFTS_IMG='https://cdn.shopify.com/s/files/1/0260/1166/4439/files/tiki_gifts_for_him_her.webp?v=1789336198';

  function setTileImage(link,src,alt){
    if(!link) return;
    var placeholder=link.querySelector('.js-header-art-placeholder');
    if(placeholder) placeholder.remove();
    var img=link.querySelector('.js-header-art-image');
    if(!img){img=document.createElement('img');img.className='js-header-art-image';link.insertBefore(img,link.firstChild);}
    if(img.getAttribute('src')!==src) img.setAttribute('src',src);
    img.setAttribute('alt',alt);
  }

  function makeTile(rail,key,href,label,src){
    var link=rail.querySelector('[data-js-header-generated="'+key+'"]');
    if(!link){
      link=document.createElement('a');
      link.className='js-header-art-slot js-header-art-link js-header-art-generated';
      link.setAttribute('data-js-header-generated',key);
      rail.appendChild(link);
    }
    link.href=href;
    link.setAttribute('aria-label',label);
    setTileImage(link,src,label);
    return link;
  }

  function ensureHeaderTileHoverStyle(){
    if(document.getElementById('js-header-tile-hover-style')) return;
    var style=document.createElement('style');
    style.id='js-header-tile-hover-style';
    style.textContent='@media (min-width:1025px){header.headertype3 .js-header-art-image{transition:transform .25s ease,filter .25s ease!important;transform-origin:center center;}header.headertype3 .js-header-art-link:hover .js-header-art-image,header.headertype3 .js-header-art-link:focus-visible .js-header-art-image{transform:scale(1.07)!important;filter:brightness(1.05)!important;}}';
    document.head.appendChild(style);
  }

  function fixHeader(){
    var header=document.querySelector('header.headertype3');
    if(!header) return;
    var rail=header.querySelector('.js-header-art-rail');
    if(!rail) return;
    ensureHeaderTileHoverStyle();
    makeTile(rail,'bundles','/collections/special-bundles-offers-by-justsmoke-me','Shop Bundles and Offers',BUNDLES_IMG);
    makeTile(rail,'gifts','/collections/gifts-for-her','Shop Gifts for Him and Her',GIFTS_IMG);
    var tiles=rail.querySelectorAll('.js-header-art-link');
    var labels=['MONTHLY BOX','SHOP £1 OR LESS','BUNDLES & OFFERS','GIFTS FOR HIM & HER'];
    var tileImages=[
      [MONTHLY_IMG,'Monthly subscription box'],
      [ONE_POUND_IMG,'Items for one pound or less'],
      [BUNDLES_IMG,'Bundles and offers'],
      [GIFTS_IMG,'Gifts for him and her']
    ];
    Array.prototype.forEach.call(tiles,function(link,i){
      if(tileImages[i]) setTileImage(link,tileImages[i][0],tileImages[i][1]);
      var cta=link.querySelector('.js-header-art-cta');
      if(!cta){cta=document.createElement('span');cta.className='js-header-art-cta';cta.setAttribute('aria-hidden','true');link.appendChild(cta);}
      cta.textContent=(labels[i]||'SHOP NOW')+'  →';
    });
    var title=header.querySelector('.header-tel-info h1.title');
    if(title){title.textContent='“You’re Gonna Need a Bigger Bong”';title.classList.add('js-bigger-bong-tagline');}
  }

  function fixGiftBar(){
    if(!document.body.classList.contains('pageindex')) return;
    var iconSection=document.querySelector('#tt-pageContent > [id$="index_section_iconbar_new"]');
    var giftSection=document.querySelector('#tt-pageContent > [id$="index_section_custom_html_freegift"]');
    if(!iconSection||!giftSection) return;
    var nav=iconSection.querySelector('.js-iconbar');
    var gift=giftSection.querySelector('.js-freegift-banner');
    if(!nav||!gift) return;

    var shell=iconSection.querySelector('.js-iconbar-gift-shell');
    if(!shell){
      shell=document.createElement('div');
      shell.className='js-iconbar-gift-shell';
      nav.parentNode.insertBefore(shell,nav);
      shell.appendChild(nav);
    }
    if(gift.parentNode!==shell) shell.appendChild(gift);

    iconSection.style.setProperty('background','transparent','important');
    iconSection.style.setProperty('background-image','none','important');
    Array.prototype.forEach.call(iconSection.querySelectorAll('.container-indent,.container,.container-fluid-custom,.subsectionbg'),function(el){
      el.style.setProperty('background','transparent','important');
      el.style.setProperty('background-image','none','important');
    });
    giftSection.style.setProperty('display','none','important');
  }

  function initBlogCarousel(){
    document.querySelectorAll('[data-js-blog-carousel]').forEach(function(shell){
      if(shell.dataset.ready==='1') return;
      shell.dataset.ready='1';
      var track=shell.querySelector('.js-compact-blog__grid');
      if(!track) return;
      shell.addEventListener('click',function(e){
        var btn=e.target.closest('[data-js-blog-dir]');
        if(!btn||!shell.contains(btn)) return;
        e.preventDefault();
        var dir=btn.getAttribute('data-js-blog-dir')==='next'?1:-1;
        var card=track.querySelector('.js-compact-blog__card');
        var gap=parseFloat(getComputedStyle(track).gap)||16;
        var amount=card ? card.getBoundingClientRect().width+gap : track.clientWidth*.75;
        track.scrollBy({left:dir*amount,behavior:'smooth'});
      });
    });
  }

  function findTrustpilotButton(){
    var root=document.getElementById('tt-pageContent');
    if(!root) return null;
    var nodes=root.querySelectorAll('a,button,[role="button"]');
    for(var i=0;i<nodes.length;i++){
      var el=nodes[i];
      if(el.closest('.js-trustpilot-review-bottom')) continue;
      var text=(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      var href=(el.getAttribute('href')||'').toLowerCase();
      if((text.indexOf('review us')!==-1&&text.indexOf('trust')!==-1)||text.indexOf('trustpilot')!==-1||href.indexOf('trustpilot')!==-1){
        if(!el.closest('.jdgm-review-widget')) return el;
      }
    }
    return null;
  }

  function moveTrustpilotButton(){
    if(!document.body.classList.contains('js-product-page')) return;
    var review=document.querySelector('#judgeme_product_reviews,.jdgm-review-widget:not(.jdgm-preview-badge),[class*="jdgm-review-widget"]');
    var button=findTrustpilotButton();
    if(!review||!button) return;
    var wrap=document.querySelector('.js-trustpilot-review-bottom');
    if(!wrap){wrap=document.createElement('div');wrap.className='js-trustpilot-review-bottom';review.parentNode.insertBefore(wrap,review);}
    if(button.parentNode!==wrap) wrap.appendChild(button);
  }

  function apply(){
    fixHeader();
    fixGiftBar();
    initBlogCarousel();
    moveTrustpilotButton();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',apply,{once:true}); else apply();
  window.addEventListener('load',apply,{once:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(apply,0);});
  [80,350,900,1800,3500].forEach(function(ms){setTimeout(apply,ms);});
})();

/* V49 header promo cleanup — use the artwork itself as each clickable tile. */
(function(){
  'use strict';

  function ensureImagesOnlyStyle(){
    var old=document.getElementById('js-header-images-only-style');
    if(old) return;
    var style=document.createElement('style');
    style.id='js-header-images-only-style';
    style.textContent='header.headertype3 .js-header-art-rail .js-header-art-slot{background:transparent!important;background-image:none!important;border:0!important;border-radius:0!important;box-shadow:none!important;padding:0!important;overflow:visible!important;text-decoration:none!important;}header.headertype3 .js-header-art-rail .js-header-art-image{display:block!important;width:100%!important;height:auto!important;max-width:100%!important;object-fit:contain!important;background:transparent!important;border:0!important;border-radius:0!important;box-shadow:none!important;margin:0!important;padding:0!important;transition:transform .25s ease,filter .25s ease!important;transform-origin:center center!important;}header.headertype3 .js-header-art-rail .js-header-art-cta{display:none!important;}@media (min-width:1025px){header.headertype3 .js-header-art-rail .js-header-art-link:hover .js-header-art-image,header.headertype3 .js-header-art-rail .js-header-art-link:focus-visible .js-header-art-image{transform:scale(1.07)!important;filter:brightness(1.05)!important;}}';
    document.head.appendChild(style);
  }

  function applyImagesOnly(){
    ensureImagesOnlyStyle();
    var rail=document.querySelector('header.headertype3 .js-header-art-rail');
    if(!rail) return;
    Array.prototype.forEach.call(rail.querySelectorAll('.js-header-art-cta'),function(cta){cta.remove();});
    Array.prototype.forEach.call(rail.querySelectorAll('.js-header-art-link'),function(link){
      link.style.setProperty('background','transparent','important');
      link.style.setProperty('background-image','none','important');
      link.style.setProperty('border','0','important');
      link.style.setProperty('box-shadow','none','important');
      link.style.setProperty('padding','0','important');
      link.style.setProperty('border-radius','0','important');
      var img=link.querySelector('.js-header-art-image');
      if(img){
        img.style.setProperty('border','0','important');
        img.style.setProperty('box-shadow','none','important');
        img.style.setProperty('border-radius','0','important');
      }
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',applyImagesOnly,{once:true}); else applyImagesOnly();
  window.addEventListener('load',applyImagesOnly,{once:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(applyImagesOnly,0);});
  [100,400,1000,1900,3700].forEach(function(ms){setTimeout(applyImagesOnly,ms);});

  var observer=new MutationObserver(function(mutations){
    for(var i=0;i<mutations.length;i++){
      if(mutations[i].addedNodes&&mutations[i].addedNodes.length){applyImagesOnly();break;}
    }
  });
  if(document.documentElement) observer.observe(document.documentElement,{childList:true,subtree:true});
})();
